import Utils from '../Utils';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import Device from "../../devices/device";
import * as constant from '../../components/Payment/constants';
import getAppConfig from '../../config/appConfig';

class UtilsPagos {

  static oneClicBuyHiddeConfirm = (isOneClicFlow, key) => {

    if (isOneClicFlow) {
      const metadataKey = 'hidden_confirm_trans_config';
      const configurationAll = Utils.getApaMetadataKey(metadataKey, '{"false": false}','all');
      const configurationHiddenList = Utils.getApaMetadataKey(metadataKey, '{"hidden_list":[]}', 'hidden_list');

      if (configurationAll) {
        return true;
      } else if (configurationHiddenList.includes(key)) {
        return true;
      } else {
        return false;
      }
    }
    else {
      return false;
    }
  };

  static oneClicBuyRedirectPlayer = (isOneClicFlow, key) => {

    if (isOneClicFlow) {
      const metadataKey = 'purchase_flow_config';
      const configurationKey = Utils.getApaMetadataKey(metadataKey, '{}', key);
      const configurationDefault = Utils.getApaMetadataKey(metadataKey, '{}', 'default');

      if (configurationKey && configurationKey === 'player') {
        return true;
      } else if (configurationDefault && configurationDefault === 'player') {
        return true;
      } else {
        return false;
      }
    }
    else {
      return false;
    }
  };

  static hasDocument = (gateway) => {
    const needId = Utils.getApaMetadataKey('regional_parameters', '{"is_id_needed": false }', 'is_id_needed') == 'true';
    const hasDocument = gateway === constant.GETWAY_HUBFIJO
      || (gateway === constant.GETWAY_HUB && needId);

    return hasDocument;
  }

  static getUpsellAlerts = (provider, format_type, offerid) => {

    const platform = Device.getDevice().getPlatform();
    const config = getAppConfig();

    let keyTitle ,keyContent, keyCancelButton, keyAsset;
    let title ,content, buttonCancel, asset;

    keyTitle = `${provider}_${format_type}_title`;
    keyContent = `${provider}_${format_type}_description`;
    keyCancelButton = `${provider}_${format_type}_cancel_button`;
    keyAsset = `${provider}_${format_type}_icon`;

    asset = Asset.get(keyAsset, false);
    title = Translator.get(keyTitle, false);
    content = Translator.get(keyContent, Translator.get('channel_not_allowed_live', 'No tiene permisos para ver este canal'));
    buttonCancel = (platform === 'android'
    && config.device_manufacturer === 'huawei'
    && config.device_type === 'ptv')
      ? Translator.get('btn_modal_ok', 'Aceptar')
      : Translator.get(keyCancelButton, 'Cancelar')
        || Translator.get('modal_default_cancel', 'Cancelar');


    if (offerid){
      //PBI regresa un solo botón de compra, o el primero
      keyAsset = `${offerid}_icon`;
      keyTitle = `${offerid}_title`;
      keyContent = `${offerid}_description`;
      keyCancelButton = `${offerid}_cancel_button`;

      asset = Asset.get(keyAsset, asset);
      title = Translator.get(keyTitle, title);
      content = Translator.get(keyContent, content);
      buttonCancel = Translator.get(keyCancelButton, buttonCancel);
    }

    return {
      asset,
      title,
      content,
      buttonCancel
    }
  }
  static getTotalAndPeriodicity (currency, price, periodicity) {
    /* Precio (La concatenación de textos se debe mostrar, solo si la llave price existe y tiene valor)
      Símbolo de divisa + Precio + Impuestos + slash + Clave para identificar la periodicidad (month, year, hour).
      Ejemplos: $ 390 / mes, S/ 29.90 Inc. IGV / mes
    */

   if(Utils.isNullOrUndefined(price) || price === ''){
     return false;
    }
    else {
      return `${this.getStringValue(currency)}${this.getStringValue(price)}${this.getStringValue(Translator.get('subscription_costTaxIcluded_complement_label_1', ''))}${this.getStringValue(Translator.get('subscription_periodicity_month_label_1', ''))}${Translator.get(periodicity,'')}`
    }
  }

  static getTotalAndPeriodicityVcard (currency, price, periodicity, producttype) {
    /* Precio (La concatenación de textos se debe mostrar, solo si la llave price existe y tiene valor)
      Símbolo de divisa + Precio + Impuestos + slash + Clave para identificar la periodicidad (month, year, hour).
      Ejemplos: $ 390 / mes, S/ 29.90 Inc. IGV / mes
    */

    const complement = Translator.get(`${producttype}_subscriptionDescription_costTaxIncluded_label`, '')

   if(Utils.isNullOrUndefined(price) || price === ''){
     return '';
    }
    else {
      // IMPORTANTE: Este método por el momento se usa desde la card solamente
      // Si este método se va a usar desde otros lados, revisar con el espacio que se pone abajo a la izquierda del string
      return ` ${this.getStringValue(currency)}${this.getStringValue(price)}${this.getStringValue(complement)}${this.getStringValue(Translator.get('subscription_periodicity_month_label_1', ''))}${Translator.get(periodicity,'')}`
    }
  }


   static getStringValue(input){
    if (typeof input === 'string' && input !== ''){
      return input + ' ';
    }
    else
    {
      return '';
    }
  }


  static shouldShowAndroidMessage(buttons=[]) {
    const iskepler = Device.getDevice().getPlatform() === 'kepler'? true: false;
    const purchasable= (buttons.filter((button)=>button.waspurchased == '0').length ==! 0)
    if(iskepler && purchasable) return true;

    if (buttons.length === 0 || buttons
      .filter((button)=>button.waspurchased == '0').length === 0) return false;

    return buttons
    .filter((button)=>button.waspurchased == '0')
    .every((button)=>{
      const {params: {android_not_mp_default = '0'} = {}} = Utils.getRequest(button.linkworkflowstart) || {};
      return button.hasOwnProperty('purchasable') &&
      button.purchasable === false &&
      android_not_mp_default == '1'
    });
  }
}

export default UtilsPagos;



// WEBPACK FOOTER //
// ./src/utils/payway/UtilsPagos.js